import React from 'react';
import Icon from '../Icons/Icon';
import $ from 'jquery';

import Accordion from './CategoryAccordion';
import CategorySelectBlock from './CategorySelectBlock';
import CategoryDropdown from './CategoryDropdown';


let w = $(window).width();
export default class CategoryArea extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isExpanded: true,
            resources: props.resources
        }
    }

    componentDidMount(){
        this.mobilize();
        $('#mobile-menu-wrapper').hide();
        if (w < 900) {
            this.closeAccordionSection();
        } else {
            this.openAccordionSection();
        }
        this.handleResize();
        $(window).resize(this.handleResize.bind(this));
    }

    handleResize() {
        let nw = $(window).width();
        if (w !== nw) {
            $(document).scrollTop(0);
        }
        this.mobilize();
        $('#mobile-menu-wrapper').hide();
        if (nw < 900) {
            this.closeAccordionSection();
            this.setState({
                isExpanded: false
            })
        } else {
            this.openAccordionSection();
            this.setState({
                isExpanded: true
            })
        }
    }

    changeCollapseExpand(){
        let documentWidth = $(document).width();
        let topbarContentWidth = $('#mainNav').outerWidth() + $('#search').outerWidth() + $('#cartLink').outerWidth() + 40;
        if (topbarContentWidth > documentWidth){
            $('#siteWrapper').addClass('mobile');
            //close_accordion_section();
        } else {
            $('#siteWrapper').removeClass('mobile');
        }
        this.setState({
            isExpanded: !this.state.isExpanded
        }, () => {
            if(this.state.isExpanded){
                this.openAccordionSection();
            } else {
                this.closeAccordionSection()
            }
        })

    }

    closeAccordionSection(){
        $('.accordion .accordion-section-title').removeClass('active');
        $('.accordion .accordion-section-content').slideUp(300).removeClass('open');
    }

    openAccordionSection(){
        $('.accordion .accordion-section-title').addClass('active');
        $('.accordion .accordion-section-content').slideDown(300).addClass('open');
    }

    mobilize(){
        let documentWidth = $(document).width();
        let topbarContentWidth = $('#mainNav').outerWidth() + $('#search').outerWidth() + $('#cartLink').outerWidth() + 40;
        if (topbarContentWidth > documentWidth){
            $('#siteWrapper').addClass('mobile');
            //close_accordion_section();
        } else {
            $('#siteWrapper').removeClass('mobile');
        }
    }

    getExpandCollapse(){
        if(this.state.isExpanded){
            let arrowData = {
                Size: 11,
                Fill: '#666666',
                name: 'ArrowUp'
            }
            return(
				<a role="button" href="javascript:void(0);" id="accordion-collapseAll" onClick={this.changeCollapseExpand.bind(this)} className="accordion-option" title={this.state.resources["PWS.CategoryArea.CollapseAll"]}>
					<span><Icon iconData={arrowData} inline={true} /></span>
        {this.state.resources["PWS.CategoryArea.CollapseAll"]}
        </a>
			)
		} else {
			let arrowData = {
			    Size: 11,
			    Fill: '#666666',
			    name: 'ArrowDown'
			}
    return(
        <a role="button" href="javascript:void(0);" id="accordion-expandAll" onClick={this.changeCollapseExpand.bind(this)} className="accordion-option" style={{display: 'inline-block'}} title={this.state.resources["PWS.CategoryArea.ExpandAll"]}>
            <span><Icon iconData={arrowData} inline={true} /></span>
{this.state.resources["PWS.CategoryArea.ExpandAll"]}
</a>
			)
}
}

	SearchCategories(data) {
	    this.props.SearchCategories(data);
	    this.handleResize();
	}

render(){

    return(
        <div id="categories-area" className="clearfix">
            <div className="accordion-options clearfix">
                {/*<a role="button" href="javascript:void(0);" onClick={this.props.resetAll.bind(this)} id="accordion-resetAll" className="accordion-option" title={this.state.resources["PWS.CategoryArea.ResetAll"]}><span style={{fontSize: 14}}>&empty;</span>{this.state.resources["PWS.CategoryArea.ResetAll"]}</a>*/}

                {this.getExpandCollapse()}

            </div>
                {/*<Accordion CategoryList={this.props.CategoryList} resources={this.state.resources} SearchCategories={this.SearchCategories.bind(this)} ActiveCategories={this.props.ActiveCategories} breadcrumbsList={this.props.breadcrumbsList} /> */}
                {/*<CategorySelectBlock CategoryList={this.props.CategoryList} resources={this.state.resources} SearchCategories={this.SearchCategories.bind(this)} ActiveCategories={this.props.ActiveCategories} breadcrumbsList={this.props.breadcrumbsList} />*/}
                <CategoryDropdown CategoryList={this.props.CategoryList} resources={this.state.resources} SearchCategories={this.SearchCategories.bind(this)} ActiveCategories={this.props.ActiveCategories} breadcrumbsList={this.props.breadcrumbsList} />
        </div>
		)
}
}



// WEBPACK FOOTER //
// ./../../Deploy/PWS/ViewModels/Components/ProductBrowse/CategoryArea.js